import {
  FormApp,
  FormControl,
  InputApp,
  ModalApp,
  SelectField,
  SwitchField,
  TextAreaInput,
} from '@/components'
import { labels } from '@/constants/labels'
import { InstanceTypes } from '@/data'

import { CreateAndEditSellTreezModalProps } from '../data/types'
import { useCreateAndEditSellTreezModal } from '../hooks'

export const CreateAndEditSellTreezModal = ({
  isOpenModal,
  handleCloseModal,
  sellTreez,
  handleSubmitSellTreez,
  isLoading,
}: CreateAndEditSellTreezModalProps) => {
  const { register, control, handleSubmit, isDisabledButton, errors } =
    useCreateAndEditSellTreezModal({
      sellTreez,
    })

  return (
    <ModalApp
      isOpenModal={isOpenModal}
      handleCloseModal={handleCloseModal}
      title={`${sellTreez ? 'Edit' : 'Create'}`}
      maxHeight="xs:max-h-[820px] md:max-h-[700px]"
      maxWidth="xs:max-w-[340px] md:max-w-[600px]"
    >
      <FormApp
        handleCancel={handleCloseModal}
        handleSubmit={handleSubmit}
        onSubmit={handleSubmitSellTreez}
        isDisabledButton={isDisabledButton}
        textButton={sellTreez ? 'Save' : 'Create'}
        isSubmitting={isLoading}
      >
        <div className="flex flex-col gap-6">
          <FormControl label="Name" isRequired messageError={errors.name?.message}>
            <InputApp
              name="name"
              placeholder="Enter name"
              register={register}
              isError={!!errors.name?.message}
            />
          </FormControl>
          <FormControl
            label={labels.description}
            isRequired
            messageError={errors.description?.message}
          >
            <TextAreaInput
              name="description"
              placeholder="Enter description"
              register={register}
              isError={!!errors.description?.message}
            />
          </FormControl>
          <fieldset className="w-full flex flex-col gap-6 self-start">
            <label>Domain</label>
            <FormControl label="Domain Name" isRequired messageError={errors.domain?.name?.message}>
              <InputApp
                name="domain.name"
                placeholder="Enter domain name"
                register={register}
                isError={!!errors.domain?.name?.message}
              />
            </FormControl>
            <div className="flex items-center justify-between max-w-64">
              <label className="text-gray-400 text-sm">Enable Custom Domain</label>
              <SwitchField name="domain.enableCustomDomain" control={control} />
            </div>
          </fieldset>
          <fieldset className="w-full flex flex-col gap-6 self-start">
            <label>Open Search</label>
            <FormControl
              label="Instance Type"
              isRequired
              messageError={errors.opensearch?.instanceType?.message}
            >
              <SelectField
                name="opensearch.instanceType"
                register={register}
                options={InstanceTypes}
                placeholder="Select type"
                control={control}
                isError={!!errors.opensearch?.instanceType?.message}
              />
            </FormControl>
            <FormControl
              label="Data Nodes"
              isRequired
              messageError={errors.opensearch?.dataNodes?.message}
            >
              <InputApp
                name="opensearch.dataNodes"
                placeholder="Enter data nodes"
                register={register}
                type="number"
                min={0}
                isError={!!errors.opensearch?.dataNodes?.message}
              />
            </FormControl>
            <FormControl
              label="Volume Size"
              isRequired
              messageError={errors.opensearch?.volumeSize?.message}
            >
              <InputApp
                name="opensearch.volumeSize"
                placeholder="Enter volume size"
                register={register}
                type="number"
                min={0}
                isError={!!errors.opensearch?.volumeSize?.message}
              />
            </FormControl>
          </fieldset>
          <fieldset className="w-full flex flex-col gap-6 self-start">
            <label>Events</label>
            <FormControl label="Source" isRequired messageError={errors.events?.source?.message}>
              <TextAreaInput
                rows={4}
                name="events.source"
                placeholder="Enter event source"
                register={register}
                isError={!!errors.events?.source?.message}
              />
            </FormControl>
            <FormControl
              label="Detail Type"
              isRequired
              messageError={errors.events?.detailType?.message}
            >
              <TextAreaInput
                rows={4}
                name="events.detailType"
                placeholder="Enter detail type"
                register={register}
                isError={!!errors.events?.detailType?.message}
              />
            </FormControl>
            <FormControl
              label="External Account ID"
              isRequired
              messageError={errors.events?.externalAccountId?.message}
            >
              <TextAreaInput
                rows={4}
                name="events.externalAccountId"
                placeholder="Enter external account ID"
                register={register}
                isError={!!errors.events?.externalAccountId?.message}
              />
            </FormControl>
          </fieldset>
        </div>
      </FormApp>
    </ModalApp>
  )
}
